<template>
  <v-dialog v-model="transactionsModal" persistent width="500">
    <v-card tile>
      <v-card-title class="headline">{{
        $t("transactionsCreate")
      }}</v-card-title>
      <v-card-text>
        <v-select
          style="margin-top: 20px"
          item-text="name"
          item-value="id"
          dense
          required
          :label="$t('transactionsLocation') + ' *'"
          :items="locationsConcise"
          v-model="computedLocation"
        >
        </v-select>
        <v-menu
          v-model="showDatePicker"
          :close-on-content-click="true"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="moment(selectedDate).format('DD.MM.YYYY')"
              :label="$t('transactionsDate') + ' *'"
              type="text"
              dense
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="selectedDate"
            no-title
            scrollable
            :locale="$i18n.locale"
          ></v-date-picker>
        </v-menu>
        <v-text-field
          :label="$t('transactionsTime') + ' *'"
          :value="moment(selectedTime).format('HH:mm')"
          v-model="selectedTime"
          dense
          type="time"
          :locale="$i18n.locale"
        ></v-text-field>
        <v-text-field
          :label="$t('transactionsAmount') + ' *'"
          dense
          type="number"
          required
          v-model="transaction.amount"
          class="mt-4"
          :error-messages="transactionAmountErrors"
          @input="$v.transaction.amount.$touch()"
          @blur="$v.transaction.amount.$touch()"
        ></v-text-field>
        <v-text-field
          :label="$t('transactionsINN')"
          dense
          type="text"
          v-model="transaction.number"
          class="mt-4"
        ></v-text-field>
        <v-textarea
          :label="$t('paymentFormComment')"
          dense
          v-model="transaction.description"
          rows="1"
          auto-grow
          class="mt-4"
        ></v-textarea>
        <small>* {{ $t("validation") }}</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="closeForm()">{{
          $t("btnExit")
        }}</v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="submitForm()"
          :disabled="$v.transaction.$invalid"
          >{{ $t("btnCreate") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  name: "TransactionsModal",

  mixins: [validationMixin],

  props: ["transactionsModal", "selectedLocation"],

  data() {
    return {
      transaction: {
        type: null,
        amount: null,
        operation_dt: null,
        description: null,
        number: null,
        debt_open: false,
        location: this.computedLocation,
        session: null,
      },
      selectedDate: moment().format("YYYY-MM-DD"),
      selectedTime: moment().format("HH:mm"),
      showDatePicker: false,
    };
  },

  validations: {
    transaction: {
      amount: {
        required,
        maxLength: maxLength(8),
      },
      location: {
        required,
      },
    },
  },

  computed: {
    ...mapGetters(["locationsConcise"]),
    computedLocation: {
      get: function () {
        return this.transaction.location;
      },
      set: function (value) {
        this.transaction.location = value;
      },
    },
    transactionAmountErrors() {
      const errors = [];
      if (!this.$v.transaction.amount.$dirty) return errors;
      !this.$v.transaction.amount.required &&
        errors.push(this.$i18n.t("validationSum"));
      !this.$v.transaction.amount.maxLength &&
        errors.push(this.$i18n.t("validationPaymentsLength"));
      return errors;
    },
  },

  methods: {
    ...mapActions(["setTransaction"]),
    combineDateTime() {
      return moment(
        `${this.selectedDate} ${this.selectedTime}`,
        "YYYY-MM-DD HH:mm"
      );
    },
    submitForm() {
      const combinedDateTime = this.combineDateTime();
      this.transaction.operation_dt = moment(combinedDateTime).format(
        "YYYY-MM-DDTHH:mm:ss.SSS[Z]"
      );
      this.setTransaction(this.transaction).then((response) => {
        this.clearTransaction();
        this.$emit("reload-transactions");
        this.$emit("close-dialog");
      });
    },
    closeForm() {
      this.clearTransaction();
      this.$emit("close-dialog");
    },
    clearTransaction() {
      this.transaction = {
        type: null,
        amount: null,
        operation_dt: null,
        description: null,
        number: null,
        debt_open: false,
        location: this.selectedLocation,
        session: null,
      };
      this.selectedDate = moment().format("YYYY-MM-DD");
      this.selectedTime = moment().format("HH:mm");
    },
  },

  watch: {
    transactionsModal(visible) {
      if (!visible) {
        this.$v.$reset();
      }
    },
    selectedLocation: {
      immediate: true,
      handler(value) {
        this.computedLocation = value;
      },
    },
  },
};
</script>
